
<div class="app-dropdown" appFocusOut (elementFocusOut) = "open = false;">
  <div class="field-name" *ngIf="labelName">
    {{ labelName}}
  </div>
  <div class="app-dropdown-header" (click)="open = !open">
    <div>
      {{ title }}
    </div>
    <div class="spacer"></div>
    <div>
      <!-- <i *ngIf="!open" class="fa fa-caret-up" aria-hidden="true"></i> -->
      <i class="fa fa-caret-down" aria-hidden="true"></i>
    </div>
  </div>
  <div [hidden]="!open" class="app-dropdown-child">
    <div *ngFor="let item of items" class="items">
      <label><input
        type="checkbox"
        [id]="item.dropdownID"
        [name]="item.dropdownDesc"
        [(ngModel)]="item.checked"
        (change)="checkValue()"
        [disabled]="item.dropdownID != '-1' ? disableItems : false"
      />{{ item.dropdownDesc }}</label>
    </div>
  </div>
</div>
